import React from 'react';
import Modal from '@omilia/modal';
import Button, { ButtonGroup } from '@omilia/button';
import styled from 'styled-components';
import { Form, Field } from 'react-final-form';
import { AsyncSelect } from '@omilia/select';

import { SAsyncSelect } from 'components/styled';

const SForm = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;

  & > div:last-child {
    margin-top: 50px;
    justify-content: right;
  }
`;

type SelectItem = {
  label: string;
  value: string;
  isDisabled: boolean;
};

type Props = {
  type: 'intent' | 'entity';
  items: SelectItem[];
  loadOptions: React.ComponentProps<typeof AsyncSelect>['loadOptions'];
  isLoading: boolean;
  onCancel: () => void;
  onReplace: (value: string) => void;
};

const selectStyles = {
  option: (provided: Object, { data }: { data: SelectItem }) => ({
    ...provided,
    ...(data.isDisabled && {
      textDecoration: 'line-through',
    }),
  }),
};

const ReplaceAllModal = ({
  type,
  items,
  loadOptions,
  isLoading,
  onCancel,
  onReplace,
}: Props) => (
  <Modal
    open
    shouldCloseOnBackdropClick
    shouldCloseOnEscPress
    glyph="replace"
    title="Replace with"
    onClose={onCancel}
  >
    <Form onSubmit={data => onReplace(data[type].value)}>
      {({ handleSubmit, submitting, pristine }) => (
        <SForm onSubmit={handleSubmit}>
          <Field
            label={`Choose ${type}`}
            name={type}
            placeholder={`Type ${type} name`}
            validate={value => !value}
          >
            {props => (
              <SAsyncSelect
                defaultOptions={items}
                isLoading={isLoading}
                loadOptions={loadOptions}
                styles={selectStyles}
                {...props.input}
                {...props}
              />
            )}
          </Field>
          <ButtonGroup>
            <Button color="secondary" variant="contained" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={pristine}
              loading={submitting}
              type="submit"
              variant="contained"
            >
              Replace
            </Button>
          </ButtonGroup>
        </SForm>
      )}
    </Form>
  </Modal>
);

export default ReplaceAllModal;
